import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export type GreetingPeriod = "morning" | "afternoon" | "evening";

export type HomeAiContent = {
  quote: string;
  attribution: string;
  pulseHeadline: string;
  pulseBody: string;
  shoppingBlurb: string;
  houseBlurb: string;
  generated: boolean;
};

export const DEFAULT_HOME_AI_CONTENT: HomeAiContent = {
  quote: "Life is better when everybody knows what’s going on.",
  attribution: "The family calendar, probably",
  pulseHeadline: "Family status: thriving-ish",
  pulseBody: "One kid at college, one still at home, and somehow everyone still needs to know what’s for dinner.",
  shoppingBlurb: "The list is waiting. Apparently groceries do not buy themselves.",
  houseBlurb: "The house has suggestions. It always has suggestions.",
  generated: false
};

const callGenerateHomeContent = httpsCallable<
  {
    householdId: string;
    dateKey: string;
    dayOfWeek: string;
    period: GreetingPeriod;
    shoppingHasItems: boolean;
    houseHasItems: boolean;
  },
  HomeAiContent
>(functions, "generateHomeContent", { timeout: 30_000 });

export function greetingPeriod(hour: number): GreetingPeriod {
  if (hour < 12) return "morning";
  if (hour < 17) return "afternoon";
  return "evening";
}

export function localDateKey(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export async function getHomeAiContent(householdId: string, date: Date, shoppingHasItems = false, houseHasItems = false): Promise<HomeAiContent> {
  const response = await callGenerateHomeContent({
    householdId,
    dateKey: localDateKey(date),
    dayOfWeek: date.toLocaleDateString("en-US", { weekday: "long" }),
    period: greetingPeriod(date.getHours()),
    shoppingHasItems,
    houseHasItems
  });
  return response.data;
}
